import { useQuery } from '@apollo/client';

import { GetUserHashedEmail2Document } from '../../graphql/queries/get-user-hashed-email.gql-types';

type UseUserHashedEmailValue = {
  isUserHashedEmailError: boolean;
  isUserHashedEmailLoading: boolean;
  userHashedEmail: string | null | undefined;
};

export const useUserHashedEmail = (): UseUserHashedEmailValue => {
  const { error, loading, data } = useQuery(GetUserHashedEmail2Document);
  const userHashedEmail = data?.viewer?.b2bProfileSettings?.hashedEmail;
  return {
    isUserHashedEmailError: !!error,
    isUserHashedEmailLoading: loading,
    userHashedEmail,
  };
};
